<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-22 10:36:13
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-12 15:46:38
 * @FilePath: \partner.chaoyongtuan.com\src\views\sampleOrder\list\components\logisticsDetailDrawer\components\updateLogisticsDialog\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog title="修改物流信息" :visible.sync="dialogVisible" width="552px" :before-close="handleClose">
		<el-form :model="form" :rules="rules" ref="ruleForm" label-width="82px">
			<el-form-item label="物流单号" prop="shipping_sn">
				<el-input
					type="text"
					@input="inputRule(form)"
					@keyup.enter.native="handleEnterEvent(form)"
					@blur="handleEnterEvent(form)"
					placeholder="请输入物流单号"
					v-model.trim="form.shipping_sn"
					maxlength="50"
				/>
			</el-form-item>
			<el-form-item label="物流公司" prop="shipping_company">
				<el-select class="width100" v-model="form.shipping_company" filterable @change="getCompanyFun" placeholder="请选择物流公司">
					<el-option :label="item.express_name" :value="item.express_name" v-for="(item, index) in companyArr" :key="index"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="submit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import throttle from 'lodash/throttle';
import { expressList, updShipping } from '@/api/cooperationProgress';
import { getDeliveryInfo } from '@/api/sampleOrder';
export default {
	name: 'updateLogisticsDialog',
	data() {
		return {
			dialogVisible: false,
			companyArr: [],
			form: {
				sample_sn: '',
				shipping_company: '',
				shipping_code: '',
				shipping_sn: '',
				status: '1',
				old_shipping_sn: '',
			},
			rules: {
				shipping_company: { required: true, message: '请选择物流公司', trigger: 'change' },
				shipping_sn: { required: true, message: '请输入物流单号', trigger: 'blur' },
			},
		};
	},
	methods: {
		show({ sample_sn, shipping_company, shipping_code, shipping_sn }) {
			this.form.old_shipping_sn = shipping_sn;
			this.form.sample_sn = sample_sn;
			this.form.shipping_company = shipping_company;
			this.form.shipping_code = shipping_code;
			this.form.shipping_sn = shipping_sn;
			this.getExpressList();
			this.dialogVisible = true;
		},
		handleClose() {
			this.form = {
				sample_sn: '',
				shipping_company: '',
				shipping_code: '',
				shipping_sn: '',
				status: '1',
				old_shipping_sn: '',
			};
			this.companyArr = [];
			this.$refs.ruleForm.resetFields();
			this.dialogVisible = false;
		},
		async getExpressList() {
			const { code, data } = await expressList({});
			if (code !== 0) return;
			this.companyArr = data || [];
		},
		getCompanyFun(e) {
			this.form.shipping_code = this.companyArr.find(item => item.express_name === e).express_code;
		},
		inputRule(form) {
			form['shipping_sn'] = form['shipping_sn'].replace(/[\W]/g, '');
		},
		async handleEnterEvent(item) {
			if (!item['shipping_sn']) return;
			try {
				let data = await getDeliveryInfo({
					deliveryCode: item['shipping_sn'],
				});
				item.shipping_company = data?.deliveryName || '';
				item.shipping_code = data?.expressCode || '';
			} catch (e) {}
		},
		submit: throttle(function () {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const { code } = await updShipping(this.form);
				if (code !== 0) return;
				this.$message.success('修改物流信息成功');
				this.$emit('getList');
				this.handleClose();
			});
		}, 1000),
	},
};
</script>

<style lang="less" scoped></style>
